import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { showModal, showNestedModal } from "../../features/modal/modalSlice";
import { BsCheck2 } from "react-icons/bs";
import { setDevamliAracInfoForDelete, setDevamliAraclarIsListesiListeleme, setDevamliAraclarKayitliArac, setDevamliAraclarSiraListesiListeleme, setSelectedDevamliArac } from "../../features/joblist/jobListSlice";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { useState } from "react";
import { firmalarimDelete, setSelectedCompanyDetail } from "../../features/firma/FirmaSlice";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  cursor: pointer;

  .container {
    width: 100%;
    width: 100% !important;
    padding: 20px;
    border-radius: 10px;
    margin: 20px 0px 0px 0px !important;
    position: relative;
    /* border: 1px solid ;
    border-color: ${({ theme }) => theme.mainBorderColor}; */
    display: flex;
    /* background-color: ${({ theme }) => theme.mainBgColor}; */
    background-color: var(--color-light);
    .row {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 15px;
      text-align: left;
      position: relative;
      .col {
        display: flex;
        flex-direction: column;
        p {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-xl);
          text-decoration: underline;
          margin-bottom: 10px;
        }
        .info {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          margin-block: 5px;
        }
        .detail-route{
            text-decoration: underline;
            color: var(--color-main);
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
        }
      }
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
      }
      .detail{
        position: absolute;
        top: 20px;
        right: 10px;
        background-color: var(--color-light);
        padding: 10px;
        border-radius: 10px;
        cursor: pointer;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
      }
    }
  }

  @media (max-width: 600px){
    .row{
      display: grid !important;
      grid-template-columns: repeat(2, 1fr) !important;
    }
  }
`;

const FirmalarimContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  const [isMoreActive, setIsMoreActive] = useState(null)

  return (
    <Container onClick={()=>{dispatch(setSelectedCompanyDetail(data)); dispatch(showModal("firmalarimDetayModal"))}} theme={theme}>
      <div className="container">
        
        <div className="row">
          <div className="col">
            <p>Firma Bilgileri</p>
            <div className="info">{data.companyName}</div>
            <div className="info">{data.companyPhone}</div>
            <div className="info">{data.companyMail}</div>
          </div>
          
          <div className="col">
            <p>Yetkili Bilgileri</p>
            <div className="info">{data.yetkili.officialName}</div>
            <div className="info">{data.yetkili.officialPhone}</div>
            <div className="info">{data.yetkili.officialMail}</div>
          </div>

          <div className="col">
            <p>Adres Bilgileri</p>
            {data.routePoints.length > 1 ? 
              <div className="detail-route">
                <span>{data.routePoints.length} adres</span>
              </div>
            :
              <>
                <div className="info">{data.routePoints[0]?.addressName}</div>
                <div className="info">{data.routePoints[0]?.cityAndTown}</div>
              </>    
            }
            
          </div>
        </div>
      </div>
    </Container>
  );
};

export default FirmalarimContainer;
